import { FileTypeConst } from '@/common/types/Files.type';
import InquiredFormList from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/components/correctiveImages/list/InquiredFormList';
import PostButton from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/correctiveImages/components/inquiredForm/components/postButton/PostButton';
import InquiredFormTabs from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/correctiveImages/components/inquiredForm/components/tabs/InquiredFormTabs';
import { getInitialPreviousCorrectiveImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getInitialPreviousCorrectiveImages/getInitialPreviousCorrectiveImagesQueryOptions';
import { getPreviousCorrectiveImagesOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getPreviousCorrectiveImages/getPreviousCorrectiveImagesOptions';
import { useCorrectiveImages } from '@/modules/adjusterReportModules/IncidentParticipants/store/correctiveImages/useCorrectiveImages';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

const InquiredCorrectiveForm = ({ type }: { type?: FileTypeConst }) => {
  const { damagedId, id } = useParams();
  const queryOptions =
    type === 'initial'
      ? (getInitialPreviousCorrectiveImagesQueryOptions({
          id: +id!,
        }) as ReturnType<typeof getPreviousCorrectiveImagesOptions>)
      : getPreviousCorrectiveImagesOptions({
          damaged_id: +damagedId!,
          id: +id!,
        });

  const { data } = useQuery(queryOptions);

  const { setPreFetchedCorrectiveImages } = useCorrectiveImages();

  useEffect(() => {
    if (data) {
      setPreFetchedCorrectiveImages(data);
    }
  }, [data]);
  return (
    <Box display={'flex'} flexDirection={'column'} gap={24}>
      <InquiredFormTabs typeRequest={type} />
      <InquiredFormList />
      <PostButton type={type} />
    </Box>
  );
};
export default InquiredCorrectiveForm;
